<form [formGroup]="form" *ngIf="ocultedLanguage">
    <div class="select-container">
        <ng-select formControlName="language" class="language" [items]="languages" bindLabel="name" [clearable]="false" bindValue="prefix"></ng-select>
    </div>
</form>